import React from "react";
import {SelectId} from "./SelectId";

const DCOptions = [
    {id:null,label:''},
    {id: 'DC', label: 'DC'},
    {id: '4 Sheet', label: '4 Sheet'}
];

export const PosterSizeDCSelect = (props) => {
    return <SelectId options={DCOptions} {...props} labelField="label" />;
}
